import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('TaskCommentAPI').extend('Uuid');

Factory.define('TaskCommentAPIWithDefaults')
  .extend('TaskCommentAPI')
  .attr('id', 'task-item-id')
  .attr('comment', 'comment')
  .attr('agentId', 'agent-id');



// WEBPACK FOOTER //
// ./factories/task_comment_api_factory.js